import { Controller } from '@hotwired/stimulus'
import { application } from 'src'

import './component.scss'

application.register(
  'full-itinerary',
  class extends Controller {
    connect() { }

    toggleWaypoints(event) {
      const colapseId = event.currentTarget.getAttribute('data-colapse');
      document.getElementById('routes' + colapseId).classList.toggle('hide-routes');
      document.getElementById('icon-down' + colapseId).classList.toggle('hide-icon');
      document.getElementById('icon-up' + colapseId).classList.toggle('hide-icon');
    }

    toggleRoute(event) {
      if (event.currentTarget.classList.contains('direction-tabs--current')) return;

      document.getElementById('outgoing-waypoints').classList.toggle('current');
      document.getElementById('ingoing-waypoints').classList.toggle('current');
      document.getElementById('ingoing-tab').classList.toggle('direction-tabs--current');
      document.getElementById('outgoing-tab').classList.toggle('direction-tabs--current');

      document.getElementById('outgoing-waypoints').classList.toggle('hidden');
      document.getElementById('ingoing-waypoints').classList.toggle('hidden');
      document.getElementById('ingoing-tab').classList.toggle('bt--outlined-active');
      document.getElementById('outgoing-tab').classList.toggle('bt--outlined-active');
    }
  }
)
